import {utils} from "@shop/frontend/web/js/utils";

class OrderHistoryCardView {
	constructor() {}

	initSetActiveCard() {
		const order = $(".order__active-card-wrap");

		if ($(window).width() > 767) {
			order.each((index, item) => {
				$(item).parent(".order__cards-container").css({display: ""});
				this.setActiveCard($(item), order.length - index);

				if ($(item).find(".order__button").length === 1) {
					$(item)
						.parents(".order__cards-container")
						.find(".order__cards-show-button")
						.hide();
				}
			});
		} else {
			order.each((index, item) => {
				$(item).parent(".order__cards-container").css({display: "none"});
			});
		}
	}

	setActiveCardClass(order, orderButtons) {
		let activeButtonsCount = 0;

		orderButtons.each((index, item) => {
			if ($(item).hasClass("order__button_active")) {
				activeButtonsCount++;
			}
		});

		if (activeButtonsCount === 0) {
			order.find(".order__button:first").addClass("order__button_active");
		}
	}

	createOrderCardsContainer(order, orderButtons) {
		if (orderButtons.length > 1) {
			order.find(".order-acquirings").append("<div class='order__cards-choice'></div>");
		}
	}

	addInactiveCardsToContainer(order, orderButtons) {
		orderButtons.each((index, item) => {
			if (!$(item).hasClass("order__button_active")) {
				order.find(".order__cards-choice").prepend(item);
			}
		});
	}

	isOrderPage() {
		return document.location.href.match(/orders/) !== null;
	}

	checkIsActiveCardDataOrder(orderButtons, index) {
		const activeCardDataOrderCount = Object.values(orderButtons).filter(item => {
			const cartCookieAttr =
				$(item).attr("href")?.match(/[0-9]/g).join("") +
				"_" +
				$(item).attr("data-acquiring-id");

			return utils.getCookie(`active-card-${index}`) === cartCookieAttr;
		});

		return activeCardDataOrderCount.length !== 0;
	}

	setDataOrder(orderButtons) {
		if (orderButtons.length > 1) {
			orderButtons.each((index, item) => {
				$(item).attr(
					"data-order",
					$(item).attr("href").match(/[0-9]/g).join("") +
						"_" +
						$(item).attr("data-acquiring-id")
				);
			});
		}
	}

	getActiveCardOrder(cardsParent) {
		return cardsParent.find(".order__button_active").data("order");
	}

	setSaveCardOrderCookie(cardsParent, orderButtons, index) {
		if (orderButtons.length > 1) {
			utils.setCookie(`active-card-${index}`, this.getActiveCardOrder(cardsParent), {
				"max-age": 86400,
			});
		}
	}

	toggleActiveClass(cardsShowBtn, cardsContainer) {
		cardsShowBtn.toggleClass("order__cards-show-button_active");

		cardsContainer.toggleClass("order__cards-choice_active");
	}

	swap(item, cardsContainer, order) {
		function checkItemParent(item) {
			if (item[0].parentNode?.nodeName === "SPAN") {
				return item[0].parentNode;
			}

			return item[0];
		}

		cardsContainer.prepend(checkItemParent(order.find(".order__button_active")));

		order.find(".order-acquirings").prepend(checkItemParent($(item)));

		cardsContainer.find(".order__button").each((index, item) => {
			$(item).removeClass("order__button_active");
		});

		$(item).addClass("order__button_active");
	}

	setActiveCard(order, index) {
		const orderButtons = order.find(".order__button");

		this.setActiveCardClass(order, orderButtons);
		this.createOrderCardsContainer(order, orderButtons);
		this.addInactiveCardsToContainer(order, orderButtons);

		const cardsContainer = order.find(".order__cards-choice");
		const cardsShowBtn = order.offsetParent().find(".order__cards-show-button");

		if (orderButtons.length > 1) {
			cardsShowBtn.css({display: "block"});
		}

		this.setDataOrder(orderButtons);

		if (this.isOrderPage()) {
			if (
				utils.getCookie(`active-card-${index}`) === undefined ||
				this.checkIsActiveCardDataOrder(orderButtons, index) === false
			) {
				this.setSaveCardOrderCookie(order, orderButtons, index);
			} else {
				this.swap(
					order.find("a[data-order=" + utils.getCookie("active-card-" + index) + "]"),
					cardsContainer,
					order
				);
			}
		}

		$(document).on("click", e => {
			if (
				order.offsetParent().has(e.target).length === 0 &&
				cardsShowBtn.hasClass("order__cards-show-button_active")
			) {
				this.toggleActiveClass(cardsShowBtn, cardsContainer);
			}
		});

		cardsShowBtn.on("click", () => {
			this.toggleActiveClass(cardsShowBtn, cardsContainer);
		});

		order.find("a").each((index, item) => {
			$(item).on("click", () => {
				this.swap(item, cardsContainer, order);
				this.setSaveCardOrderCookie(order, orderButtons, index);
			});
		});
	}
}

export const orderHistoryCardView = new OrderHistoryCardView();
